<template>
  <div class="own-reports">
    <div class="own-reports-header">
      <h2 v-if="!reports.length">Моите отчети</h2>
      <h2 v-else>Моите последно направени отчети (до 30 бр.)</h2>
      <div class="btns">
        <button class="btn btn-new" @click="newReport()">
          <span class="miv">H</span>
          Нов отчет
        </button>
        <button
          class="btn btn-excel"
          v-if="reports.length"
          @click="exportFile()"
        >
          <span class="miv">E</span>
          Експорт в Excel
        </button>
      </div>
    </div>
    <div class="table-wrapper">
      <p v-if="!reports.length" class="no-reports">Нямате направени отчети</p>
      <table v-else class="table" ref="table">
        <thead>
          <tr>
            <th>Дата</th>
            <th>Дата на създаване</th>
            <th>Фирма</th>
            <th>Проект</th>
            <th>Обект</th>
            <th class="center">Части</th>
            <th class="center">Отчетени хора</th>
            <!-- <th class="center">Общо отчетено време</th> -->
            <th class="center">Отчетени материали</th>
            <th class="center">Отчетени дейности</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="report in searchFilter()"
            :key="`findReport-${report._id}`"
            @click="viewReport(report._id)"
            :class="{ 'tr-invalid': report.isInvalid }"
          >
            <!-- 14.12. - report.createdAt changed to report.date -->
            <td>
              <span class="no-wrap">{{ report.date | formatDate }} г.</span>
            </td>
            <td>
              <span class="no-wrap" v-if="new Date(report.createdAt).getTime() >= new Date('2022-12-01').getTime()"
                >{{ report.createdAt | formatDate }} г.</span
              >
            </td>
            <td class="td-company-name">
              <img
                class="td-invalid-flag"
                v-if="report.isInvalid"
                src="../assets/img/flag_yes.svg"
                alt="invalid"
              />{{ report.company.companyName }}
            </td>
            <td>{{ report.project.projectName }}</td>
            <td>{{ report.object.objectName }}</td>
            <td
              class="center underline-hover"
              :title="report.partsList.join(', ')"
            >
              {{ report.partsList.length }}
            </td>
            <td class="center underline-hover" :title="report.workersList">
              {{ report.workers.length }}
            </td>
            <!-- <td class="center">
              <div class="worktime-indicator-wrapper">
                <p
                  v-if="calculateHours(report.date, report.startHour, report.endHour).normal * report.workers.length"
                >
                  <span class="worktime-indicator">НРВ</span>
                  {{calculateHours(report.date, report.startHour, report.endHour).normal * report.workers.length}} ч.
                </p>
                <p
                  v-if="calculateHours(report.date, report.startHour, report.endHour).overtime * report.workers.length"
                >
                  <span class="worktime-indicator overtime-indicator">ИРВ 1</span>
                  {{calculateHours(report.date, report.startHour, report.endHour).overtime * report.workers.length}} ч.
                </p>
                <p
                  v-if="calculateHours(report.date, report.startHour, report.endHour).holiday * report.workers.length"
                >
                  <span class="worktime-indicator holiday-indicator">ИРВ 2</span>
                  {{calculateHours(report.date, report.startHour, report.endHour).holiday * report.workers.length}} ч.
                </p>
              </div>
            </td> -->
            <td class="center">{{ report.materials.length }}</td>
            <td class="center">{{ report.activities.length }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- BUTTONS FOR MOBILE -->
    <footer class="modal-footer mobile">
      <div
        class="new-content-data-item-toggle-circle mobile excel"
        v-if="this.reports.length"
        @click="exportFile()"
      >
        <span class="miv">E</span>
      </div>
      <div
        class="new-content-data-item-toggle-circle mobile"
        @click="newReport()"
      >
        <span class="miv">L</span>
      </div>
    </footer>
  </div>
</template>

<script>
import hours from "./mixins/hours.js";
import { mapGetters } from "vuex";
import * as XLSX from 'xlsx';

export default {
  mixins: [hours],
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "getUser",
      // ...
    ]),
  },
  data() {
    return {
      reports: [],
      search: "",
    };
  },
  methods: {
    // Filter reports by date, companyName, projectName or objectName
    searchFilter() {
      return this.reports.filter((r) => {
        return (
          r.date.toLowerCase().includes(this.search.toLowerCase()) ||
          r.company.companyName
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          r.project.projectName
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          r.object.objectName.toLowerCase().includes(this.search.toLowerCase())
          // || r.part.partName.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
    viewReport(id) {
      this.$router.push(`/reports/edit/${id}`);
    },
    getPartsList(r) {
      let parts = [];

      for (let x of ["materials", "activities"]) {
        for (let y of r[x]) {
          for (let ro of y.rows) {
            if (ro.part) {
              if (parts.indexOf(ro.part.partName) === -1) {
                parts.push(ro.part.partName);
              }
            }
          }
        }
      }

      return parts;
    },
    getWorkersList(r) {
      let workers = [];
      for (let w of r.workers) {
        workers.push(w.name);
      }
      return workers.join(", ");
    },
    getReports() {
      this.$store.dispatch("startLoading");
      let id = this.getUser._id;
      let url = `${process.env.VUE_APP_BASE_URI}/report/myreports/${id}`;
      this.$http
        .get(url)
        .then((response) => {
          this.reports = response.data;
          this.reports.map((r) => {
            r.workersList = this.getWorkersList(r);
            r.partsList = this.getPartsList(r);
          });
          this.$store.dispatch("stopLoading");
          // console.log(this.reports.map(r=>r.company.companyName));
        })
        .catch((error) => console.log(error));
    },
    newReport() {
      this.$router.push("/reports/new");
    },
    formatReports() {
      let formatedReport = [];
      let rows = this.reports;

      for (let row in rows) {
        // ROW OBJECT
        formatedReport.push({
          createdAt: rows[row].createdAt,
          createdBy: rows[row][Object.keys(rows[row])[0]].name,
          company: rows[row][Object.keys(rows[row])[1]].companyName,
          project: rows[row][Object.keys(rows[row])[2]].projectName,
          object: rows[row][Object.keys(rows[row])[3]].objectName,
          date: rows[row].date,
          startHour: rows[row].startHour,
          endHour: rows[row].endHour,
          // overtime: rows[row].overtime,
          // part: rows[row].part,
          workers: rows[row][Object.keys(rows[row])[10]].length,
          materials: rows[row][Object.keys(rows[row])[11]].length,
          activities: rows[row][Object.keys(rows[row])[12]].length,
          part: rows[row][Object.keys(rows[row])[8]].partName,
        });
      }
      return formatedReport;
    },
    // Export To Excel
    exportFile() {
      // let worksheet = XLSX.utils.json_to_sheet(this.formatReports());
      let worksheet = XLSX.utils.table_to_sheet(this.$refs.table);
      let new_workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(new_workbook, worksheet, `Reports`);
      XLSX.writeFile(new_workbook, `report-${Date.now()}.xlsx`);
    },
  },
  mounted() {
    this.getReports();
  },
  updated() {
    // Handle search input
    this.$root.$on("sendSearchInput", (data) => {
      this.search = data;
      // console.log(this.search);
    });
  },
  destroyed() {
    this.$root.$off("sendSearchInput");
  },
};
</script>

<style scoped>
.own-reports {
  padding: 10px 40px;
}
.own-reports-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.table-wrapper {
  overflow: auto;
}
.desktop {
  display: flex;
}
.mobile {
  display: none;
}
.no-reports {
  background-color: #f0f0f7;
  font-size: 18px;
  text-align: center;
  padding: 20px;
}
.underline-hover {
  color: #3b86ff;
  font-weight: 700;
}
.underline-hover:hover {
  text-decoration: underline;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .mobile {
    display: flex;
  }
  .table-wrapper {
    overflow: auto;
  }
  .own-reports {
    padding: 10px 15px;
  }
  .own-reports-header {
    display: none;
  }
  .btns.mobile {
    position: fixed;
    display: flex;
    float: left;
    flex-direction: column-reverse;
    justify-items: flex-end;
  }
  .new-content-data-item-toggle-circle {
    width: 50px;
    height: 50px;
  }
  .new-content-data-item-toggle-circle.mobile {
    bottom: 20px;
    cursor: pointer;
    position: fixed;
    right: 20px;
  }
  .new-content-data-item-toggle-circle.mobile.excel {
    background-color: green;
    bottom: 75px;
    cursor: pointer;
    right: 20px;
    position: fixed;
  }
  .new-content-data-item-toggle-circle .miv {
    border: 0px;
    font-size: 20px;
  }
  .modal-footer {
    background-color: #f0f0f7;
    height: 125px;
    padding: 0px;
  }
}
</style>
